var $9b4b47ae278c0f51$exports = {};
$9b4b47ae278c0f51$exports = {
    "collapse": `Skjul`,
    "expand": `Udvid`
};


export {$9b4b47ae278c0f51$exports as default};
//# sourceMappingURL=da-DK.module.js.map
